// test2625
(2625 && 0);
